/**
 * Player profile — the identity a player picks on the Splash screen
 * (`docs/design/flow/screens1.jsx` → `SplashScreen`). Carried through the
 * Room Browser into the lobby. Cosmetic only; element is acquired in-game.
 */
/** Splash-screen name validation bounds (mirrors the prototype input). */
export const PLAYER_NAME_MIN = 2;
export const PLAYER_NAME_MAX = 14;
//# sourceMappingURL=player.js.map